import { api } from "./drogal-api"

export const PostData = (body) =>{
    try{
        return api.http.post(api.addresses.gravarvacinacao, body)
    }catch{
        return false
    }
}


export const getVaccineData = (params) =>{
    return api.http.get(`${api.addresses.dadosvacina}${params}`)
}

export const getFarmaceuticos = () =>{
    return api.http.get(api.addresses.farmaceuticos)
}

export const getTypeDose = () => {
    return[
        {
            Code: 1,
            Name: 'Única'
        },
        {
            Code: 2,
            Name: 'D1'
        },
        {
            Code: 3,
            Name: 'D2'
        }
    ]
}

export const getType = () =>{
    return[
        {
            Code: 'COMPANHEIRO',
            Name: 'COMPANHEIRO'
        },
        {
            Code: 'COMPANHEIRA',
            Name: 'COMPANHEIRA'
        },
        {
            Code: 'CONJUGE',
            Name: 'CONJUGE'
        },
        {
            Code: 'ENTEADO',
            Name: 'ENTEADO'
        },
        {
            Code: 'ESPECIAL',
            Name: 'ESPECIAL'
        },
        {
            Code: 'ESPOSA',
            Name: 'ESPOSA'
        },
        {
            Code: 'EX-CONJUGE',
            Name: 'EX-CONJUGE'
        },
        {
            Code: 'FILHA',
            Name: 'FILHA'
        },
        {
            Code: 'FILHO',
            Name: 'FILHO'
        },
        {
            Code: 'MARIDO',
            Name: 'MARIDO'
        },
        {
            Code: 'OUTROS',
            Name: 'OUTROS'
        },
        {
            Code: 'TITULAR',
            Name: 'TITULAR'
        },
        {
            Code: 'TUTELADA',
            Name: 'TUTELADA'
        },
        {
            Code: 'TUTELADO',
            Name: 'TUTELADO'
        },
    ]
}

export const formatarCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.substring(0, 11); 
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

    return cpf;
};

export const formatarDate = (data) => {
    
    try{
     
     if(data.length < 8) return data

     if (data.trim() !== '') {
     
        const dataObj = new Date(data);
     
        if (!isNaN(dataObj.getTime())) {
     
          const dia = String(dataObj.getDate()).padStart(2, '0');
          const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
          const ano = dataObj.getFullYear();
     
          return `${dia}/${mes}/${ano}`;
        }
      }     

      const numberOnly = data.replace(/\D/g, '');          
      const dateFormatted = numberOnly.replace(/^(\d{2})(\d{2})(\d{4})$/,'$1/$2/$3');
      return dateFormatted;
    }catch{
        return data;
    }
}

export const getFarmaceuticoLocalStorage = () => {
    try {
        const farmaceutico = localStorage.getItem('Farmaceutico');
        let _farmaceutico =  farmaceutico ? JSON.parse(farmaceutico) : "";
        return _farmaceutico
    } catch (error) {        
        return {"Farmaceutico": "", "CRF":""};
    }
}

export const FormatDateDB = (value) =>{

    var partesData = value.split('/');
    var dia = partesData[0];
    var mes = partesData[1];
    var ano = partesData[2];

    var data = new Date(ano, mes - 1, dia);
    var dataFormatada = data.toISOString().split('T')[0];
    return dataFormatada
} 

export const newVacinacaoModel = {
    "Id": 0,
    "Paciente": "",
    "Cpf": "",
    "DataNascimento": null,
    "ProfissionalSaude": "",
    "Gestante": "",
    "Tipo": "",
    "Titular": "",
    "Matricula": null,
    "Confirmacao": false,
    "DataHoraConfirmacao": new Date().toString(),
    "Farmaceutico": getFarmaceuticoLocalStorage(),    
    "CRF": "",
    "Vacina": "INFLUVAC TETRA 1X1 SERINGA PREENCHIDA 0,5ML",
    "DoseAplicada": "Única",
    "NumeroLote": "N04",
    "Fabricante": "Abbott",
    "Empresa": "PREVICAT SOC PREVIDENCIARIA CATERPILLAR",
    "DrogalCNPJ":"54.375.647/0165-54",
    "Cancelado":false,
    "DataHoraCancelamento":new Date().toString()
}

export const formatarDataHora = (valor) => {
      if (!valor) return "";
      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) return "";
      return data.toLocaleString("pt-BR");
    };

/**
 * Retorna apenas a DATA no formato DD/MM/YYYY
 * @example "16/04/2026"
 */
export const formatDate = (valor) => {
  if (!valor) return "";
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return "";
  
  return data.toLocaleDateString("pt-BR");
};

/**
 * Retorna apenas a HORA no formato HH:MM:SS
 * @example "13:45:00"
 */
export const formatTime = (valor) => {
  if (!valor) return "";
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return "";

  return data.toLocaleTimeString("pt-BR");
};